<template>
  <div class="SearchStock flex">
    <div class="flex search-stock-container">
      <!-- <el-select v-model="search_stock"  ref="searchStock" filterable remote autocomplete="off" placeholder="Search Company E.g. Infosys"
        class="custom-seach-input" size="small" clearable :loading="loading" :remote-method="searchStockList"
        @focus="focusInput" @change="handleStock(search_stock)" @clear="clearInputField()">
        <el-option v-for="stock in stocksList" :key="stock.id" :label="stock.name" :value="stock.id">
          <span class="searched-stock-title">{{ stock.name }}</span>
          &nbsp;
          <span class="input-label-gray" v-if="stock.symbol">({{ stock.symbol }})</span>
        </el-option>
      </el-select>
      <i class="el-icon-search search-icon" v-if="!search_stock"></i> -->

      <div class="dropdown-wrapper">
        <!-- Input field for searching -->
        <input type="text" v-model="search_stock" autocomplete="off" ref="searchInput" placeholder="Search Company E.g. Infosys" @input="searchStockList" @keydown.up.prevent="navigateUp" @keydown.down.prevent="navigateDown" @keydown.enter.prevent="selectHighlightedItem" />
        <i class="el-icon-search search-icon" v-if="!search_stock"></i>
        <i class="el-icon-circle-close cross-icon" v-if="search_stock.trim().length" @click="clearInputField()"></i>

        <!-- Dropdown with a notch -->
        <div v-if="search_stock && stocksList.length && !loading" class="dropdown">
          <!-- <div class="notch"></div> -->
          <ul class="dropdown-list">
            <li v-for="(stock, index) in stocksList" :key="index" :class="{ highlighted: index === highlightedIndex }" @mouseover="highlightItem(index)" @click="selectItem(stock)" class="stock-item">
              <span class="searched-stock-title">{{ stock.name }}</span>
              &nbsp;
              <span class="input-label-gray" v-if="stock.symbol">({{ stock.symbol }})</span>
            </li>
          </ul>
        </div>

        <div v-if="search_stock && loading" class="dropdown">
          <ul class="dropdown-list">
            <li class="text-center" style="color: #999">
              <span>Loading</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { serverAddr } from '../networkConfig';
import { EventBus } from '../eventBus';
import { setTimeout } from 'core-js';
var _ = require('lodash');

export default {
  name: 'SearchStock',

  data() {
    return {
      selectActionType: 'stock',
      stocksList: [],
      loading: false,
      search_stock: '',
      highlightedIndex: -1, // Tracks the highlighted item
    };
  },

  mounted() {
    EventBus.$on('clearedSelectedFilter', (filter) => {
      this.search_stock = '';
    });

    EventBus.$on('selectedSector', (filter) => {
      this.search_stock = '';
    });

    EventBus.$on('selectedSearchedExpert', (filter) => {
      //emitted event from desktop and mobile filter
      this.search_stock = '';
    });
  },

  mounted() {
    setTimeout(() => {
      this.$refs.searchInput.focus();
    }, 100);
    //   document.addEventListener("click", this.handleClickOutsideOfDiv);
  },

  methods: {
    navigateUp() {
      if (this.highlightedIndex > 0) {
        this.highlightedIndex--;
        this.ensureVisible();
      }
    },

    navigateDown() {
      if (this.highlightedIndex < this.stocksList.length - 1) {
        this.highlightedIndex++;
        this.ensureVisible();
      }
    },

    ensureVisible() {
      const dropdown = this.$el.querySelector('.dropdown-list');
      const item = dropdown.children[this.highlightedIndex];
      if (item) {
        const { offsetTop, offsetHeight } = item;
        const { scrollTop, clientHeight } = dropdown;

        // Scroll if item is above or below the visible area
        if (offsetTop < scrollTop) {
          dropdown.scrollTop = offsetTop;
        } else if (offsetTop + offsetHeight > scrollTop + clientHeight) {
          dropdown.scrollTop = offsetTop + offsetHeight - clientHeight;
        }
      }
    },

    highlightItem(index) {
      this.highlightedIndex = index;
    },

    selectItem(item) {
      this.search_stock = item.name;
      this.handleStock(item);
    },

    selectHighlightedItem() {
      if (this.highlightedIndex !== -1) {
        this.selectItem(this.stocksList[this.highlightedIndex]);
      }
    },

    searchStockList: _.debounce(function () {
      this.stocksList = [];
      this.highlightedIndex = -1; // Reset highlight on a new search
      this.loading = true;

      if (this.search_stock.trim().length) {
        serverAddr
          .post('/recommendation/v1/read-stock', {
            search: this.search_stock,
            key: this.selectActionType,
          })
          .then((response) => {
            if (response.data.status) {
              this.stocksList = response.data.data;
            } else {
              this.stocksList = [];
            }

            this.loading = false;
          })
          .catch((error) => {
            console.log('error', error);
            this.loading = false;
            this.stocksList = [];
          });
      } else {
        this.stocksList = [];
      }
    }, 300),

    clearInputField() {
      this.search_stock = '';
      this.stocksList = [];
      this.highlightedIndex = -1; // Reset highlight on a new search

      EventBus.$emit('clearedSearchedStock', '');
    },

    // handleClickOutsideOfDiv(event) {
    //   console.log(event, this.$el);
    //   if (event.target != 'li.stock-item.highlighted' || event.target != 'span.searched-stock-title') {
    //     this.search_stock = "";
    //     this.stocksList = [];
    //     this.highlightedIndex = -1; // Reset highlight on a new search
    //     this.loading = false;
    //   }
    // },

    handleStock(item) {
      if (Object.keys(item).length) {
        let filtered_stock = this.stocksList.filter((e) => {
          return e.id == item.id;
        })[0];

        this.stocksList = []; // Clear dropdown

        EventBus.$emit('selectedStock', filtered_stock);

        this.stocksList = [];

        // this.hideStockList();
        // this.search_stock = item.name;
        // this.search_stock = '';

        serverAddr
          .post('/stockants_pro/stock_tracking_view/', {
            stock_id: filtered_stock.id,
          })
          .then((response) => {
            if (response.data.status) {
              console.log('stock id sent to stockants server');
            } else {
              console.log('unable to send stock id to stockants server');
            }
          })
          .catch(function (error) {
            console.log('error');
          });
      } else {
        this.stocksList = []; // Clear dropdown
        EventBus.$emit('clearedSearchedStock', '');
      }
    },
  },

  beforeDestroy() {
    EventBus.$off();
    // document.removeEventListener("click", this.handleClickOutsideOfDiv);
  },
};
</script>

<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.SearchStock .search-stock-container {
  position: relative;
  // width: 300px;
  //   margin: 0 auto;
}

.dropdown-wrapper {
  position: relative;
  width: 300px; /* Adjust width as needed */

  input {
    background-color: #fff;
    background-image: none;
    border-radius: 40px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    height: 32px;
    line-height: 32px;
    font-size: 13px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color 0.2scubic-bezier (0.645, 0.045, 0.355, 1);
    transition: border-color 0.2scubic-bezier (0.645, 0.045, 0.355, 1);
    width: 100%;
  }
}

.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 100%;
  width: auto;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 10;
  margin-top: 5px;
}

// .notch {
//   position: absolute;
//   top: -8px;
//   left: 15px;
//   width: 10px;
//   height: 10px;
//   background: white;
//   transform: rotate(45deg);
//   border-left: 1px solid #ccc;
//   border-top: 1px solid #ccc;
// }

.dropdown-list {
  max-height: 150px; /* Add scrolling */
  overflow-y: auto;
  margin: 0;
  padding: 0;
  list-style: none;
}

.dropdown-list li {
  height: 34px;
  line-height: 34px;
  font-size: 12px;
  padding: 0 20px;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
  color: #878787;
  transition: background-color 0.2s ease;
}

.dropdown-list li:hover,
.dropdown-list li.highlighted {
  background-color: #f5f7fa;
  color: $primary-theme-color;
}

.dropdown-list .stock-item:hover {
}

@media screen and (max-width: 768px) {
  .SearchStock .search-stock-container {
    min-width: 130px !important;
    width: 100%;
  }
}
@media screen and (max-width: 500px) {
  .dropdown-wrapper {
    position: relative;
    width: 220px;
  }
}
</style>
